<template>
  <div>

    <card title="Affiliate Invitations" :subtitle="subtitle">
      <div>
        <Affiliate-Invitations-Table :hidePosition="!singleView" :hideCompany="singleView"/>
      </div>
      <!-- <div slot="footer" class="stats">
       <i class="far fa-clock"/> This Month
      </div> -->
    </card>

  </div>
</template>

<script>
export default {
  name: 'Affiliate-Invitations-Card',
  props: {
    singleView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subtitle () {
      return 'Unaccepted invitations'
    }
  }
}
</script>

<style>

</style>